import { Component, HostBinding } from '@angular/core';

@Component({
    selector: 'lui-list',
    template: `<ng-content></ng-content>`,
    standalone: false
})
export class ListComponent {
  @HostBinding('role') list = 'list';
}
